import React from 'react';
import styled from 'styled-components';

const CenterOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
`;

const LoseContainer = styled.div`
	background-color: white;
	padding: 40px;
	border-radius: 12px;
	text-align: center;
	max-width: 500px;
	width: 90%;
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3); 
	color: black;
`;

const Title = styled.div`
	font-size: 36px;
	font-weight: bold;
	color: #FF6347; 
	margin-bottom: 20px
`;

const ContainerStatus = styled.div`
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	font-size: 24px;
`;

const StatusRow = styled.div`
	text-align: center;
`;

const ContainerButton = styled.div`
	display: flex;
	gap: 20px;
	justify-content: center;
`;

const Button = styled.button`
	padding: 12px 24px;
	font-size: 16px;
	background-color: ${props => (props.type === 'restart' ? '#4CAF50' : '#FF6347')};
	color: white;
	border: none;
	border-radius: 5px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: ${props => (props.type === 'restart' ? '#45a049' : '#e05343')};
	}
`;
const exitGame = () => {
    window.location.href = "/games";
  };
const LoseGame = ({status, portrait, pixelSize, theme3d, restartClick}) => (
	<CenterOverlay>
		<LoseContainer portrait={portrait} pixelSize={pixelSize} theme3d={theme3d}>
			<Title portrait={portrait}>Game Over</Title>
			<ContainerStatus>
				<StatusRow>Score: {status.score}</StatusRow>
				<StatusRow>Level: {status.level}</StatusRow>
				<StatusRow>Lines: {status.lines}</StatusRow>
				<StatusRow>Lives: {status.lives}</StatusRow>
			</ContainerStatus>
			<ContainerButton portrait={portrait}>
				<Button type="restart" onClick={() => restartClick()}>Restart</Button>
				<Button type="exit"  onClick={exitGame}>Exit</Button>
			</ContainerButton>
		</LoseContainer>
	</CenterOverlay>
);

export default LoseGame;